import { addResourceBundle } from '@egw/i18n'
import en from './src/i18n/locales/en.json'

addResourceBundle('en', 'features-investment', en)

export * from './src/components'
export * from './src/pages/investments'
export * from './src/pages/redesign'
